import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import ActTable from "../components/actTable";
import Navbar from "../components/Navbar";

const ActPage = () => {
    const { url } = useParams();
    const navigate = useNavigate();
    const [table, setTable] = useState([]);
    const [title, setTitle] = useState("");
    useEffect(() => {
        const getPage = async () => {
            const resp = await fetch(`https://bareact-backend-596718606544.us-central1.run.app/scrape?url=${url}`)
            console.log(resp)
            const respJson = await resp.json()
            console.log(respJson)
            setTable(respJson.table);
            setTitle(respJson.title || respJson.heading || "");
        }
        getPage()

    }, [])
    return (
        <div className="min-h-screen bg-[#0c0a29] relative flex flex-col items-center">
            <Navbar />
            <div className="background-circle circle-3 z-0"></div>
            <div className="background-circle circle-4 z-0"></div>


            <main className="w-full px-4 md:px-36 py-8 z-10">
                <div className="flex items-center mb-6">
                    <button onClick={() => navigate(-1)} className="text-white">
                        <ArrowLeft />
                    </button>
                    <h1 className="text-xl font-semibold text-yellow-500 ml-4">
                        {title || "Bare Act"}
                    </h1>
                </div>
                {table.length > 0 ? (
                    <div className="flex justify-center">
                        <ActTable data={table} />
                    </div>
                ) : (
                    <p className="text-white text-center">Loading table...</p>
                )}
            </main>

        </div>
    );
}

export default ActPage;
